import { Chart, DoughnutController, ArcElement, Tooltip, Legend } from 'chart.js';

Chart.register(DoughnutController, ArcElement, Tooltip, Legend);

export default element => {
    const rangeContainers = element.querySelectorAll('[data-chart-input-container]');
    const chartTags = element.querySelectorAll('[data-chart-id]');
    const fallbackColors = JSON.parse(element.getAttribute('data-chart-fallback-colors'));
    const interestDiscountPercentage = element.getAttribute('data-interest-discount-percentage');
    const monthlyFeeLabels = element.querySelectorAll('[data-monthly-fee-label], #månadsavgift');
    let chartsData = [];
    let charts = [];
    let toolTips = element.querySelectorAll('.tooltip-wrapper');

    let showMonthlyFeeButton = element.querySelector("#showMonthlyFeeButton");
    let monthlyFeeInputs = element.querySelectorAll('[data-monthly-fee-input], #derome-fee');
    let prePrices = [];

    function init() {

        if (rangeContainers && rangeContainers.length) {
            Array.from(rangeContainers).forEach(container => {
                const rangeInput = container.querySelector('[data-chart-range]');
                const textInput = container.querySelector('[data-chart-text]');
                const valueTag = container.querySelector('[data-chart-value]');


                let timeout;
                if (rangeInput) {
                    rangeInput.addEventListener('input', (e) => {
                        if (timeout) {
                            clearTimeout(timeout);
                        }

                        timeout = setTimeout(() => {
                            updateCharts();
                            valueTag.innerText = e.target.value.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + e.target.getAttribute('data-chart-prefix');
                        }, 10);

                    });
                }

                if (textInput) {
                    let cursorPos;
                    textInput.addEventListener('input', (e) => {
                        let inputValue = e.target.value.replace(/[^0-9]/g, '');
                        inputValue = inputValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                        cursorPos = e.target.selectionStart;
                        e.target.value = inputValue;
                        const cursorDifference = e.data === null ? -1 : 1;
                        e.target.setSelectionRange(cursorPos + cursorDifference, cursorPos + cursorDifference);
                    });

                    textInput.addEventListener('change', (e) => {
                        const chartInput = e.target.getAttribute('data-chart-houseprice');
                        const cursorPos = e.target.selectionStart;
                        let inputValue = e.target.value.replace(/[^0-9]/g, '');
                        if (inputValue === "")
                            inputValue = 0;

                        let min = parseInt(textInput.getAttribute('min') || 0);
                        let max = parseInt(textInput.getAttribute('max') || 0);


                        if (inputValue) {
                            inputValue = parseInt(inputValue);
                        }

                        inputValue = Math.max(Math.min(parseInt(inputValue), parseInt(max)), parseInt(min));

                        if (chartInput === 'new' || chartInput === 'preowned') {
                            element.querySelectorAll(`[data-chart-id="${chartInput}"]`).forEach(chartTag => {
                                chartTag.setAttribute('data-chart-houseprice', inputValue);
                            });
                        }

                        e.target.value = inputValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                        e.target.setSelectionRange(cursorPos, cursorPos);
                        updateCharts();
                    });
                }
            });
        }

        if (chartTags && chartTags.length) {
            buildCharts();

        }


        if (toolTips && toolTips.length > 0) {
            Array.from(toolTips).forEach((el) => {
                const hoverBtn = el.querySelector('i');
                const container = el.querySelector('.tooltip');
                const closeBtn = el.querySelector('button');

                let isHovering = false;

                const openTooltip = () => container.classList.add('open');
                const closeTooltip = () => container.classList.remove('open');
                const toggleTooltip = () => container.classList.toggle('open');

                hoverBtn.addEventListener('mouseenter', () => {
                    isHovering = true;
                    openTooltip();
                });

                hoverBtn.addEventListener('mouseleave', () => {
                    isHovering = false;
                    setTimeout(() => {
                        if (!isHovering) closeTooltip();
                    }, 100);
                });

                container.addEventListener('mouseenter', () => {
                    isHovering = true;
                });

                container.addEventListener('mouseleave', () => {
                    isHovering = false;
                    setTimeout(() => {
                        if (!isHovering) closeTooltip();
                    }, 100);
                });

                hoverBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    if (!hoverBtn) return;

                    if (!hoverBtn.classList.contains('open')) {
                        container.classList.add('open')
                    }
                });

                closeBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    closeTooltip();
                });

                container.addEventListener('touchend', (e) => {
                    e.stopPropagation();
                });

                container.addEventListener('click', (e) => {
                    e.stopPropagation();
                });


            });

            document.addEventListener('click', () => {
                Array.from(toolTips).forEach((el) => {
                    const container = el.querySelector('.tooltip');
                    container.classList.remove('open');
                });
            });
            document.addEventListener('touchend', () => {
                Array.from(toolTips).forEach((el) => {
                    const container = el.querySelector('.tooltip');
                    container.classList.remove('open');
                });
            });
        }

        InitShowMonthlyFee();
    }

    function updateChart(chart) {
        const descriptionTags = element.querySelectorAll('.doughnut-description');
        const updatedCost = updateMonthlyCost(element, chart);
        const parent = chart.chart.canvas.parentElement;
        const totalTag = parent.querySelector('[data-chart-total]');
        const chartLabels = chart.chart.data.labels;
        const interestIndex = chartLabels.indexOf('Ränta');
        const amortizationIndex = chartLabels.indexOf('Amortering');
        const monthlyFeeIndex = chartLabels.indexOf('Månadsavgift');
        const chartDescriptionTags = Array.from(descriptionTags).filter(
            x => x.getAttribute('data-chart-description') === chart.id
        );

        let newFee = false;
        let preownedFee = false;

        if (chartDescriptionTags) {
            chartDescriptionTags.forEach(chartDescriptionTag => {
                const chartDescriptionTotalTag = chartDescriptionTag.querySelector('[data-totalprice-tag]');
                const chartDescriptionInterestTag = chartDescriptionTag.querySelector('[data-interest-tag]');
                const chartDescriptionAmortizationTag = chartDescriptionTag.querySelector('[data-amortization-tag]');
                const chartDescriptionMonthlyFeeTag = chartDescriptionTag.querySelector('[data-monthly-fee-tag]');
                const chartDescriptionMonthlyPreownedFeeTag = chartDescriptionTag.querySelector('[data-monthly-preowned-fee-tag]');

                if (chartDescriptionInterestTag) {
                    chartDescriptionInterestTag.innerText = updatedCost.monthlyInterest.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr';
                }

                if (chartDescriptionAmortizationTag) {
                    chartDescriptionAmortizationTag.innerText = updatedCost.monthlyAmortization.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr';
                }

                if (chartDescriptionTotalTag) {
                    chartDescriptionTotalTag.innerText = updatedCost.totalHouseCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr';
                }

                if (chartDescriptionMonthlyFeeTag) {
                    chartDescriptionMonthlyFeeTag.innerText = updatedCost.monthlyNewFee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr';
                    newFee = true;
                }

                if (chartDescriptionMonthlyPreownedFeeTag) {
                    chartDescriptionMonthlyPreownedFeeTag.innerText = updatedCost.monthlyPreownedFee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr';
                    preownedFee = true;
                }
            });
        }

        chart.housePrice = updatedCost.totalHouseCost;
        if (interestIndex == -1) {
            chartLabels.push('Ränta');
            chart.chart.data.datasets[0].data.push(updatedCost.monthlyInterest);
        } else {
            chart.chart.data.datasets[0].data[interestIndex] = updatedCost.monthlyInterest;
        }

        if (amortizationIndex == -1) {
            chartLabels.push('Amortering');
            chart.chart.data.datasets[0].data.push(updatedCost.monthlyAmortization);
        } else {
            chart.chart.data.datasets[0].data[amortizationIndex] = Math.round(updatedCost.monthlyAmortization);
        }

        if (!excludeMonthlyFee()) {
            if (monthlyFeeIndex == -1) {
                chartLabels.push('Månadsavgift');
                if (newFee)
                    chart.chart.data.datasets[0].data.push(updatedCost.monthlyNewFee);
                else if (preownedFee)
                    chart.chart.data.datasets[0].data.push(updatedCost.monthlyPreownedFee);
            } else {
                if (newFee)
                    chart.chart.data.datasets[0].data[monthlyFeeIndex] = updatedCost.monthlyNewFee;
                else if (preownedFee)
                    chart.chart.data.datasets[0].data[monthlyFeeIndex] = updatedCost.monthlyPreownedFee;
            }
        } else {
            if (monthlyFeeIndex != -1) {
                chartLabels.splice(monthlyFeeIndex, 1);
                chart.chart.data.datasets[0].data.splice(monthlyFeeIndex, 1);
            }
        }

        totalTag.innerText = Math.round(updatedCost.totalMonthlyPayment).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr/mån';

        chart.chart.update();
    }

    function excludeMonthlyFee() {
        let excludeMonthlyFeeIndex = false;
        monthlyFeeLabels.forEach((x) => {
            if (x.style.display === "none")
                excludeMonthlyFeeIndex = true;
        });
        return excludeMonthlyFeeIndex;
    }

    function InitShowMonthlyFee() {
        if (showMonthlyFeeButton) {
            let label = element.querySelector("#showMonthlyFeeLabel");
            showMonthlyFeeButton.addEventListener('click', () => {
                if (showMonthlyFeeButton.innerText === "Lägg till") {
                    showMonthlyFeeButton.innerText = "Ta bort";

                    if (label)
                        label.innerText = "Ta bort månadsavgift";

                    monthlyFeeInputs.forEach((x, index) => {
                        x.style.display = "block";
                        if (prePrices[index] !== null && prePrices[index] !== undefined) {
                            let input = x.querySelector("input");
                            input.value = prePrices[index];
                        }
                    });
                    monthlyFeeLabels.forEach((x) => {
                        x.style.display = "flex";
                    });
                }
                else {
                    label.innerText = "Vid bostadsrätt lägg till månadsavgift";
                    showMonthlyFeeButton.innerText = "Lägg till";
                    if (label)
                        label.style.display = "block";
                    monthlyFeeInputs.forEach((x, index) => {
                        x.style.display = "none";
                        let input = x.querySelector("input");
                        prePrices[index] = input.value;
                    });
                    monthlyFeeLabels.forEach((x) => {
                        x.style.display = "none";
                    });
                }
                updateCharts();
            });
        }
    }

    function updateCharts() {
        charts.forEach(chart => {
            updateChart(chart);
        });
    }

    function buildCharts() {
        chartTags.forEach(chart => {
            const dataAttribute = chart.getAttribute('data-chart-data');
            const extraDataAttribute = chart.getAttribute('data-chart-extra-data');
            const houseTotal = chart.getAttribute('data-chart-houseprice');

            if (!dataAttribute || !dataAttribute.length || !houseTotal) return;

            chart.getContext('2d').canvas.width = 250;
            chart.getContext('2d').canvas.height = 250;

            const parsedExtraAttribute = JSON.parse(extraDataAttribute);
            const parsedAttribute = JSON.parse(dataAttribute)
            const interestColor = parsedExtraAttribute.interestColor;
            const amortizationColor = parsedExtraAttribute.amortizationColor;
            const monthlyFeeColor = parsedExtraAttribute.monthlyFeeColor;

            const labels = Array.from(parsedAttribute).map(x => {
                return [x.Name, x.Description]
            });
            const data = Array.from(parsedAttribute).map(x => x.Price);

            const colors = [
                ...Array.from(parsedAttribute).map(x => x.Color || '').filter(x => x.length),
                interestColor,
                amortizationColor,
                monthlyFeeColor
            ];

            chartsData.push({
                tag: chart,
                houseTotal: houseTotal,
                data: {
                    datasets: [
                        {
                            data: data,
                            backgroundColor: colors.length - 3 === labels.length ? colors : fallbackColors,
                            borderColor: colors.length - 3 === labels.length ? colors : fallbackColors,
                            borderWidth: 1,
                            cutout: '75%',

                        },
                    ],
                    labels: labels,
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            enabled: false,
                            position: 'nearest',
                            callbacks: {
                                title: function (chartItems) {
                                    const label = chartItems[0].label;
                                    const price = chartItems[0].formattedValue;

                                    if (typeof label === 'string') {
                                        return `${label}: ${price} kr/mån`;
                                    }

                                    return `${label[0]}: ${price} kr/mån`;
                                },
                                label: function (context) {
                                    const label = context.label;

                                    if (typeof label === 'string') {
                                        return "";
                                    }

                                    return label[1];
                                }
                            },
                            external: function (context) {
                                let tooltipEl = context.chart.canvas.parentElement.querySelector('.custom-tooltip');

                                if (!tooltipEl) {
                                    tooltipEl = document.createElement('div');
                                    tooltipEl.id = 'custom-tooltip';
                                    tooltipEl.className = 'custom-tooltip';
                                    tooltipEl.innerHTML = '<table></table>';
                                    tooltipEl.style.position = 'absolute';
                                    tooltipEl.style.pointerEvents = 'none';
                                    document.body.appendChild(tooltipEl);
                                }

                                const tooltipModel = context.tooltip;

                                if (tooltipModel.opacity === 0) {
                                    tooltipEl.style.opacity = 0;
                                    return;
                                }

                                if (tooltipEl._rafId) {
                                    cancelAnimationFrame(tooltipEl._rafId);
                                }

                                tooltipEl.classList.remove('above', 'below', 'no-transform');
                                if (tooltipModel.yAlign) {
                                    tooltipEl.classList.add(tooltipModel.yAlign);
                                } else {
                                    tooltipEl.classList.add('no-transform');
                                }

                                function getBody(bodyItem) {
                                    return bodyItem.lines;
                                }

                                if (tooltipModel.body) {
                                    const titleLines = tooltipModel.title || [];
                                    const bodyLines = tooltipModel.body.map(getBody);
                                    let innerHtml = '<thead>';
                                    const color = tooltipModel.labelColors[0].backgroundColor;

                                    titleLines.forEach(function (title) {
                                        if (title.length < 1) return;
                                        innerHtml += `<tr><th><div class="color" style="background-color: ${color}"></div>` + title + '</th></tr>';
                                    });

                                    innerHtml += '</thead><tbody>';

                                    bodyLines.forEach(function (body, i) {
                                        let style = '';
                                        if (body.length > 0) {
                                            if (body[0].length > 40) {
                                                style += 'min-width: 250px'
                                            }
                                        }
                                        innerHtml += '<tr><td style="' + style + ';">' + body + '</td></tr>';
                                    });
                                    innerHtml += '</tbody>';

                                    let tableRoot = tooltipEl.querySelector('table');
                                    if (innerHtml) {
                                        tableRoot.innerHTML = innerHtml;
                                    }
                                }

                                tooltipEl._rafId = requestAnimationFrame(() => {
                                    tooltipEl.style.left = context.tooltip._eventPosition.x + 'px';
                                    tooltipEl.style.top = context.tooltip._eventPosition.y + 'px';
                                    tooltipEl.style.opacity = 1;
                                    tooltipEl._rafId = null;
                                });
                            }
                        }
                    },
                    fullWidth: true,
                }
            });
        });

        if (chartsData && chartsData.length) {
            chartsData.forEach(chart => {
                const chartObject = buildChart(chart);
                charts.push({ id: chart.tag.getAttribute('data-chart-id'), chart: chartObject, housePrice: chart.houseTotal, monthlyExpenses: chart.data.datasets[0].data });
            });

            charts.forEach(chart => {

                const updatedCost = updateMonthlyCost(element, chart);
                const parent = chart.chart.canvas.parentElement;
                const totalTag = parent.querySelector('[data-chart-total]');
                const descriptionTags = element.querySelectorAll('.doughnut-description');
                const chartLabels = chart.chart.data.labels;
                const interestIndex = chartLabels.indexOf('Ränta');
                const amortizationIndex = chartLabels.indexOf('Amortering');
                const monthlyFeeIndex = chartLabels.indexOf('Månadsavgift');
                const chartDescriptionTag = Array.from(descriptionTags).find(x => x.getAttribute('data-chart-description') === chart.id);
                const chartDescriptionTotalTag = chartDescriptionTag.querySelector('[data-totalprice-tag]');
                const chartDescriptionInterestTag = chartDescriptionTag.querySelector('[data-interest-tag]');
                const chartDescriptionAmortizationTag = chartDescriptionTag.querySelector('[data-amortization-tag]');
                const chartDescriptionMonthlyFeeTag = chartDescriptionTag.querySelector('[data-monthly-fee-tag]');
                const chartDescriptionMonthlyPreownedFeeTag = chartDescriptionTag.querySelector('[data-monthly-preowned-fee-tag]');

                if (chartDescriptionInterestTag) {
                    chartDescriptionInterestTag.innerText = updatedCost.monthlyInterest.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr';
                }

                if (chartDescriptionAmortizationTag) {
                    chartDescriptionAmortizationTag.innerText = updatedCost.monthlyAmortization.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr';
                }

                if (chartDescriptionMonthlyFeeTag) {
                    chartDescriptionMonthlyFeeTag.innerText = updatedCost.monthlyNewFee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr';
                }

                if (chartDescriptionMonthlyPreownedFeeTag) {
                    chartDescriptionMonthlyPreownedFeeTag.innerText = updatedCost.monthlyPreownedFee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr';
                }

                if (chartDescriptionTotalTag) {
                    chartDescriptionTotalTag.innerText = updatedCost.totalHouseCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr';
                }

                if (interestIndex == -1) {
                    chartLabels.push('Ränta');
                    chart.chart.data.datasets[0].data.push(updatedCost.monthlyInterest);
                } else {
                    chart.chart.data.datasets[0].data[interestIndex] = updatedCost.monthlyInterest;
                }

                if (amortizationIndex == -1) {
                    chartLabels.push('Amortering');
                    chart.chart.data.datasets[0].data.push(updatedCost.monthlyAmortization);
                } else {
                    chart.chart.data.datasets[0].data[amortizationIndex] = updatedCost.monthlyAmortization;
                }

                if (!excludeMonthlyFee()) {
                    if (monthlyFeeIndex == -1) {
                        chartLabels.push('Månadsavgift');
                        if (chartDescriptionMonthlyFeeTag)
                            chart.chart.data.datasets[0].data.push(updatedCost.monthlyNewFee);
                        else if (chartDescriptionMonthlyPreownedFeeTag)
                            chart.chart.data.datasets[0].data.push(updatedCost.monthlyPreownedFee);
                    } else {
                        if (chartDescriptionMonthlyFeeTag)
                            chart.chart.data.datasets[0].data[monthlyFeeIndex] = updatedCost.monthlyNewFee;
                        else if (chartDescriptionMonthlyPreownedFeeTag)
                            chart.chart.data.datasets[0].data[monthlyFeeIndex] = updatedCost.monthlyPreownedFee;
                    }
                }
                else {
                    if (monthlyFeeIndex != -1) {
                        chartLabels.splice(monthlyFeeIndex, 1);
                        chart.chart.data.datasets[0].data.splice(monthlyFeeIndex, 1);
                    }
                }


                chart.chart.update();
                totalTag.innerText = Math.round(updatedCost.totalMonthlyPayment).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr/mån';
            });
        }


        resize();
        updateCharts();
    }

    function buildChart({ tag, data, options, plugins }) {
        let chart = new Chart(tag, {
            type: 'doughnut',
            data,
            options,
            plugins
        });


        return chart;
    }

    function calculateMonthlyPayment(principal, interestRate, monthlyExpenses, amortization, total, isNewHouse, deromeNewFee, deromePreOwnedFee, excludeDeromeFee) {
        const yearlyInterestTotal = principal * (interestRate / 100);
        let monthlyInterestTotal = Math.round(yearlyInterestTotal / 12);
        const amortizationMonthlyPayment = isNewHouse ? 0 : (principal * (amortization / 100)) / 12;
        const totalHouseCost = parseInt(total);
        const monthlyDeromeFee = !excludeDeromeFee ? isNewHouse ? parseInt(deromeNewFee) : parseInt(deromePreOwnedFee) : 0;

        const applyDiscount = Array.from(toolTips).some((x) => x.querySelector("h3").textContent === "Ränta" && x.closest("[data-chart-description]").getAttribute("data-chart-description") === (isNewHouse ? "new" : "preowned"));

        if (interestDiscountPercentage !== '' && applyDiscount) {
            const percentage = parseInt(interestDiscountPercentage);
            if (percentage >= 1) {
                monthlyInterestTotal *= 1.0 - (percentage / 100.0);
                const isFloatingPoint = (monthlyInterestTotal / 5.0) % 1 != 0;
                if (isFloatingPoint) {
                    monthlyInterestTotal =  Math.floor(monthlyInterestTotal / 5.0) * 5;
                }

            }
        }

        return {
            totalMonthlyPayment: monthlyInterestTotal + monthlyExpenses.reduce((a, b) => a + b, 0) + amortizationMonthlyPayment + monthlyDeromeFee,
            monthlyInterest: Math.round(monthlyInterestTotal),
            monthlyAmortization: Math.round(amortizationMonthlyPayment),
            monthlyNewFee: Math.round(deromeNewFee),
            monthlyPreownedFee: Math.round(deromePreOwnedFee),
            totalHouseCost: totalHouseCost
        };
    }

    function updateMonthlyCost(element, chart) {
        const houseTotal = element.querySelector(`[data-chart-houseprice="${chart.id}"]`).value.toString().replace(/\s/g, "");
        const deromeNewFeeElement = element.querySelector('[data-chart-houseprice="derome-new-fee"]');
        let deromeNewFee = "0";
        if (deromeNewFeeElement !== null && deromeNewFeeElement !== undefined) {
            deromeNewFee = deromeNewFeeElement.value.toString().replace(/\s/g, "");
        }
        const deromePreownedFeeElement = element.querySelector('[data-chart-houseprice="derome-preowned-fee"]');
        let deromePreownedFee = "0";
        if (deromePreownedFeeElement !== null && deromePreownedFeeElement !== undefined) {
            deromePreownedFee = deromePreownedFeeElement.value.toString().replace(/\s/g, "");
        }
        const interestInput = element.querySelector('[data-chart-range="interest"]');
        const amortizationInput = element.querySelector('[data-chart-range="amortization"]');
        const loanInput = element.querySelector('[data-chart-range="loan"]');
        const chartLabels = chart.chart.data.labels;
        const interestIndex = chartLabels.indexOf('Ränta');
        const amortizationIndex = chartLabels.indexOf('Amortering');
        const monthlyFeeIndex = chartLabels.indexOf('Månadsavgift');
        const excludeIndexes = [interestIndex, amortizationIndex, monthlyFeeIndex, monthlyFeeIndex].filter(index => index !== -1);
        const interestRate = parseFloat(interestInput.value);
        const amortizationRate = parseFloat(amortizationInput.value);
        const loanPercentage = parseFloat(loanInput.value) / 100;
        const totalLoan = parseFloat(houseTotal) * loanPercentage;
        const loan = parseFloat(totalLoan);

        let excludeMonthlyFeeIndex = excludeMonthlyFee();
        const monthlyPayments = calculateMonthlyPayment(loan, interestRate, Array.from(chart.monthlyExpenses).filter((_, index) => !excludeIndexes.includes(index)), amortizationRate, houseTotal, chart.id === "new", deromeNewFee, deromePreownedFee, excludeMonthlyFeeIndex);

        return monthlyPayments;
    }

    function resize() {
        if (charts && charts.length > 0) {
            charts.forEach(chart => {
                let hasChanged = false;
                const canvas = chart.chart.canvas;
                const parentWidth = canvas.parentElement.parentElement.clientWidth;

                if (window.innerWidth < 1024) {
                    canvas.style.width = `225px`;
                    canvas.style.height = `225px`;
                    hasChanged = true;
                } else {
                    if (canvas.width !== 250 || canvas.height !== 250) {
                        canvas.style.width = `250px`;
                        canvas.style.height = `250px`;
                        hasChanged = true;
                    }
                }

                if (hasChanged) {
                    chart.chart.resize();
                }
            });
        }
    }

    function wrapText(text, maxLineLength = 40) {
        const words = text.split(' ');
        const lines = [];
        let line = '';

        words.forEach(word => {
            if ((line + word).length > maxLineLength) {
                lines.push(line.trim());
                line = '';
            }
            line += word + ' ';
        });

        if (line) lines.push(line.trim());
        return lines;
    }

    window.addEventListener('DOMContentLoaded', () => resize());
    window.addEventListener('resize', resize);
    init();
}